import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const DateTime = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>DATE/TIME IS OF THE ESSENCE</Text>

      <Text style={styles.text}>
        1. Written acceptance of all parties will be on or before{' '}
        <Text style={styles.DangerText}>
          {contract?.timeline?.offerGoodUntillDate || 'Not specified'}
        </Text>
        .
      </Text>

      <Text style={styles.text}>
        2. The Settlement Date and all other dates and times identified for the
        performance of any obligations of this Agreement are of the essence and
        are binding.
      </Text>

      <Text style={styles.text}>
        3. The Execution Date of this Agreement is the date when Buyer and
        Seller have indicated full acceptance of this Agreement by signing it.
        For purposes of this Agreement, the number of days will be counted from
        the Execution Date, excluding the day this Agreement was executed and
        including the last day of the time period. All changes to this Agreement
        should be initialed and dated.
      </Text>

      <Text style={styles.text}>
        4. The Settlement Date is not extended by any other provision of this
        Agreement and may only be extended by mutual written agreement of the
        parties.
      </Text>

      <Text style={styles.text}>
        5. Certain terms and time periods are pre-printed in this Agreement as a
        convenience to the Buyer and Seller. All pre-printed terms and time
        periods are negotiable and may be changed by striking out the
        pre-printed text and inserting different terms acceptable to all
        parties, except where restricted by law.
      </Text>
    </View>
  );
};

export default DateTime;
